import { OperationPayload } from '../operation-payload.model';

export class CreateLeadPayload implements OperationPayload {
  path = '/leeds/list';
  rowId: number;
}
